export default function DiscoverSisters() {
  return (
    <section id="about" className="py-16 sm:py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        {/* Section Header */}
        <div className="text-center mb-12 sm:mb-16">
          <p className="text-[#4a7fa5] text-xs tracking-[0.4em] uppercase mb-3 font-light">
            Our Story / قصتنا
          </p>
          <h2
            className="text-[#1a2744] text-3xl sm:text-4xl font-light tracking-wide"
            style={{ fontFamily: "'Playfair Display', serif" }}
          >
            Discover Blue Moon
          </h2>
          <p
            className="text-[#1a2744] text-2xl sm:text-3xl font-bold mt-1"
            style={{ fontFamily: "'Noto Naskh Arabic', serif", direction: "rtl" }}
          >
            اكتشفي صالون وسبا القمر الأزرق
          </p>
          <p
            className="text-[#1a2744]/60 text-sm mt-1"
            style={{ fontFamily: "'Noto Naskh Arabic', serif", direction: "rtl" }}
          >
            الخوض 7، شارع مزون، مسقط — وجهتك الأولى للجمال في سلطنة عمان
          </p>
          <p className="text-gray-400 text-sm mt-3 tracking-wide max-w-lg mx-auto">
            Muscat&apos;s finest beauty destination nestled in the heart of Al Koudh
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 sm:gap-6">
          {/* Big image */}
          <div className="md:col-span-2 relative overflow-hidden group cursor-pointer h-[280px] sm:h-[400px] md:h-[460px]">
            <img
              src="https://storage.readdy-site.link/project_files/d68a7650-c072-4c33-8608-46dabc6c4849/2d72a372-7f6f-41da-a480-501ec443d5e7_WhatsApp-Image-2026-03-26-at-10.50.27-AM-1.jpeg?v=2f0e79243e27dbc091f4f37db03fff9f"
              alt="Inside Blue Moon Beauty Salon Al Koudh Muscat Oman"
              className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-700"
              loading="lazy"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/40 to-transparent"></div>
            <div className="absolute bottom-4 left-4">
              <span className="text-white text-sm tracking-widest uppercase font-light block">Our Salon</span>
              <span className="text-white/70 text-sm" style={{ fontFamily: "'Noto Naskh Arabic', serif" }}>صالوننا في الخوض، مسقط</span>
            </div>
          </div>

          {/* Right stacked */}
          <div className="md:col-span-1 grid grid-cols-2 md:grid-cols-1 gap-4">
            <div className="relative overflow-hidden group cursor-pointer h-[180px] md:h-[215px]">
              <img
                src="https://public.readdy.ai/ai/img_res/2d426e47aa9bf868d29db029dbde7663.jpg"
                alt="Blue Moon Beauty Salon Muscat clients"
                className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-700"
                loading="lazy"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent"></div>
              <div className="absolute bottom-3 left-3">
                <span className="text-white text-xs tracking-widest uppercase font-light block">Our Clients</span>
                <span className="text-white/70 text-xs" style={{ fontFamily: "'Noto Naskh Arabic', serif" }}>عميلاتنا</span>
              </div>
            </div>
            <div className="relative overflow-hidden group cursor-pointer h-[180px] md:h-[215px]">
              <img
                src="https://readdy.ai/api/search-image?query=luxury%20beauty%20spa%20reception%20area%20gold%20and%20blue%20elegant%20decor%20muscat%20oman%20salon%2C%20modern%20reception%20desk%2C%20floral%20arrangement%2C%20premium%20ambiance&width=500&height=400&seq=bm_about003&orientation=portrait"
                alt="Blue Moon Beauty Salon reception Al Koudh"
                className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-700"
                loading="lazy"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent"></div>
              <div className="absolute bottom-3 left-3">
                <span className="text-white text-xs tracking-widest uppercase font-light block">Our Spa</span>
                <span className="text-white/70 text-xs" style={{ fontFamily: "'Noto Naskh Arabic', serif" }}>سبا القمر الأزرق</span>
              </div>
            </div>
          </div>
        </div>

        {/* About text - fully bilingual side-by-side */}
        <div className="mt-10 grid grid-cols-1 md:grid-cols-2 gap-8 items-start bg-[#f8f7f4] p-6 sm:p-8">
          <div>
            <h3 className="text-[#1a2744] text-lg font-medium mb-3" style={{ fontFamily: "'Playfair Display', serif" }}>About Blue Moon</h3>
            <p className="text-gray-500 text-sm leading-relaxed">
              <strong className="text-[#1a2744]">Blue Moon Beauty Salon &amp; Spa</strong> is Muscat&apos;s premier beauty destination
              located at Al Koudh 7, Mazoon Street. We combine traditional Omani warmth with
              modern beauty expertise to deliver an unmatched experience for every client.
            </p>
            <p className="text-gray-500 text-sm leading-relaxed mt-3">
              From expert hair styling and facials to relaxing massages and nail art, our
              skilled team ensures you leave feeling and looking your absolute best. Visit us in Al Koudh, Muscat.
            </p>
          </div>
          <div dir="rtl">
            <h3 className="text-[#1a2744] text-xl font-bold mb-3" style={{ fontFamily: "'Noto Naskh Arabic', serif" }}>عن صالون القمر الأزرق</h3>
            <p className="text-gray-500 text-sm leading-relaxed" style={{ fontFamily: "'Noto Naskh Arabic', serif" }}>
              <strong className="text-[#1a2744]">صالون وسبا القمر الأزرق</strong> هو وجهتك الأولى للجمال في مسقط، يقع في الخوض 7، شارع مزون. نجمع بين الدفء العماني الأصيل والخبرة الجمالية الحديثة لتقديم تجربة لا مثيل لها.
            </p>
            <p className="text-gray-500 text-sm leading-relaxed mt-3" style={{ fontFamily: "'Noto Naskh Arabic', serif" }}>
              من تصفيف الشعر الاحترافي والجلسات إلى المساج المريح وتنسيق الأظافر، يحرص فريقنا على أن تغادري بإطلالة مثالية وشعور رائع. زورينا في الخوض، مسقط.
            </p>
          </div>
        </div>

        {/* Stats */}
        <div className="grid grid-cols-2 sm:grid-cols-4 gap-6 mt-12 sm:mt-16 border-t border-[#ece8e0] pt-10 sm:pt-12">
          {[
            { value: "5+", label: "Years in Muscat", labelAr: "سنوات في مسقط" },
            { value: "1K+", label: "Happy Clients", labelAr: "عميل سعيد" },
            { value: "15+", label: "Expert Specialists", labelAr: "متخصص محترف" },
            { value: "9", label: "Service Categories", labelAr: "فئات الخدمة" },
          ].map((stat) => (
            <div key={stat.label} className="text-center">
              <p
                className="text-[#c6a864] text-3xl sm:text-4xl font-light mb-1"
                style={{ fontFamily: "'Playfair Display', serif" }}
              >
                {stat.value}
              </p>
              <p className="text-gray-500 text-xs tracking-widest uppercase font-light">{stat.label}</p>
              <p className="text-[#1a2744]/70 text-sm mt-0.5 font-medium" style={{ fontFamily: "'Noto Naskh Arabic', serif" }}>{stat.labelAr}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
